import React from 'react';

const frontendSkills = [
    ['React.js', 'bx bxl-react'],
    ['Next.js', 'bx bxl-react'],
    ['TypeScript', 'bx bxl-typescript'],
    ['JavaScript', 'bx bxl-javascript'],
    ['HTML', 'bx bxl-html5'],
    ['CSS', 'bx bxs-file-css'],
    ['bootstrap', 'bx bxl-bootstrap'],
    ['Web Applications', 'bx bx-window-alt'],
    ['Responsive UI', 'bx bx-devices'],
    ['Razor Pages', 'bx bxs-layer']
];

const Frontend = () => {
    return (
        <div className="skills__content">
            <h3 className="skills__title bold">Frontend Development</h3>

            <div className="skills__box">
                {frontendSkills.map(([name, icon]) => (
                    <div className="skills__data" key={name}>
                        <i className={icon}></i>
                        <h3 className="skills__name">{name}</h3>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Frontend;
